import { rem } from 'polished';
import styled, { css } from 'styled-components';

import { Paragraph as P, Header as H } from '@vimeo/iris/typography';

import Icon from '../icon-error.svg';

export const Paragraph = styled(P).attrs({ size: '2' })`
  color: white;
  margin-top: ${rem(14)};
`;

export const Header = styled(H).attrs({ size: '2' })`
  color: white;
`;

export const ErrorIcon = styled(Icon)`
  margin-bottom: ${rem(14)};
`;

export const MessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
`;
export const Background = styled.div<{ navIsHidden: boolean }>`
  background: black;
  height: calc(100vh + 80px);
  width: 100vw;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  position: absolute;
`;

export const Grid = styled.div<{ navIsHidden: boolean }>`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  display: grid;
  margin: 0 auto;
  padding: ${rem(25)};
  position: relative;
  grid-template-columns: repeat(auto-fill, minmax(${rem('280px')}, 1fr));
  min-width: ${rem(330)};
  left: 0;
  ${({ navIsHidden }: { navIsHidden: boolean }) => css`
    top: ${navIsHidden ? rem(80) : rem(64)};
  `}
  width: 100vw;
  background: black;

  @media only screen and (max-width: 767px) {
    padding: ${rem(10)};
  }
`;

export const PaginationWrapper = styled.div<{ navIsHidden: boolean }>`
  padding-right: 20px;
  background: black;
  padding-bottom: 100px;
  position: relative;
  ${({ navIsHidden }: { navIsHidden: boolean }) => css`
    top: ${navIsHidden ? rem(80) : rem(64)};
  `}
`;
